{
  "title": "Settings",
  "tabs": {
    "general": "General",
    "tags": "Tags",
    "dance": "Dance Configuration",
    "eventTypes": "Event Types",
    "billing": "Billing",
    "email": "Email",
    "media": "Media",
    "calendar": "Calendar",
    "notifications": "Notifications",
    "appearance": "Appearance",
    "features": "Features",
    "contract": "Contracts",
    "backup": "Backup & Restore"
  },
  "status": {
    "label": "Status:",
    "enabled": "Enabled",
    "disabled": "Disabled"
  },
  "actions": {
    "add": "Add",
    "edit": "Edit",
    "delete": "Delete",
    "remove": "Remove",
    "enable": "Enable",
    "disable": "Disable",
    "archive": "Archive",
    "restore": "Restore",
    "close": "Close",
    "copy": "Copy"
  },
  "general": {
    "schoolIdentity": "School identity",
    "schoolFallback": "School",
    "logo": "Logo",
    "logoHint": "Click the image to upload a PNG, JPG, or WebP. Shown in the nav and on the login page.",
    "removeLogo": "Remove logo",
    "schoolName": "School name",
    "tagline": "Tagline",
    "taglinePlaceholder": "Shown under the name on the login page",
    "contactDetails": "Contact details",
    "contactEmail": "Contact email",
    "phone": "Phone",
    "website": "Website",
    "address": "Address",
    "regional": "Regional",
    "timezone": "Timezone",
    "defaultLanguage": "Default language",
    "primaryCurrencyNote1": "Primary currency is",
    "primaryCurrencyNote2": "— change it under",
    "primaryCurrencyNote3": "(it re-books the ledger).",
    "breakMonths": "Break months",
    "breakMonthsHintPre": "Months the school is on break (recurring every year). Recurring classes are suspended and monthly fees follow each fee's break rule (set per fee in",
    "breakMonthsHintPost": ").",
    "saving": "Saving…",
    "saveChanges": "Save changes",
    "months": {
      "jan": "Jan",
      "feb": "Feb",
      "mar": "Mar",
      "apr": "Apr",
      "may": "May",
      "jun": "Jun",
      "jul": "Jul",
      "aug": "Aug",
      "sep": "Sep",
      "oct": "Oct",
      "nov": "Nov",
      "dec": "Dec"
    }
  },
  "tags": {
    "newTag": "New tag",
    "namePlaceholder": "Tag name",
    "colorLabel": "Tag color",
    "addTag": "Add Tag",
    "empty": "No tags yet"
  },
  "dance": {
    "categoriesTypes": "Categories & Types",
    "newCategory": "New category",
    "categoryPlaceholder": "Category name",
    "addCategory": "Add Category",
    "typePlaceholder": "New type…",
    "addType": "Add Type",
    "levelsHeading": "Proficiency Levels",
    "levelPlaceholder": "New level…",
    "addLevel": "Add Level"
  },
  "eventTypes": {
    "hint": "The categories available when creating an event (Competition, Show, Workshop…). A type still used by existing events can't be deleted.",
    "newType": "New event type",
    "placeholder": "e.g. Recital",
    "addType": "Add Type",
    "empty": "No event types yet"
  },
  "billing": {
    "primaryCurrencyHeading": "Primary currency",
    "primaryCurrencyHint": "The currency your accounting is reported in. Payments and expenses in other currencies are converted to it (at the transaction-date rate) for the financial overview.",
    "currencyCode": "Currency code",
    "currencyCodePlaceholder": "e.g. RON",
    "primaryCurrencyNote": "Changing this later doesn't re-convert past entries — set it before recording payments.",
    "currenciesHeading": "Currencies",
    "currenciesHint": "The currencies your school transacts in. These are the only options offered when recording fees, expenses, and event payments — so codes stay consistent (no typos or casing drift).",
    "code": "Code",
    "codePlaceholder": "e.g. EUR",
    "nameOptional": "Name (optional)",
    "namePlaceholder": "e.g. Euro",
    "noCurrencies": "No currencies yet.",
    "primarySuffix": "· primary",
    "inUse": "in use",
    "feeDefinitionsHeading": "Fee definitions",
    "feeName": "Name",
    "feeNamePlaceholder": "e.g. Monthly tuition",
    "feeType": "Type",
    "feeTypes": {
      "monthly": "Monthly",
      "yearly": "Yearly",
      "occasional": "Occasional",
      "event": "Event"
    },
    "billed": "Billed",
    "scope": {
      "student": "Per student",
      "household": "Per family"
    },
    "amount": "Amount",
    "defaultAmount": "Default amount",
    "selectPlaceholder": "Select…",
    "dueDay": "Due day",
    "breakBehavior": "In break months",
    "breakBehaviors": {
      "bill": "Bill normally",
      "pause": "Pause (skip)",
      "reduce": "Reduce by %"
    },
    "reduceBy": "Reduce by %",
    "addFee": "Add Fee",
    "familyShort": "family",
    "studentShort": "student",
    "dueDaySuffix": "due day {day}",
    "archivedSuffix": "archived",
    "paymentsOne": "{count} payment",
    "paymentsMany": "{count} payments",
    "historyOnly": "history — archive only",
    "historyOnlyTitle": "Fees with payment history can't be edited or deleted — archive instead",
    "noFees": "No fees defined yet",
    "priceTiersHeading": "Price tiers",
    "tierName": "Name",
    "tierNamePlaceholder": "e.g. Sibling discount",
    "adjustment": "Adjustment",
    "adjustmentTypes": {
      "percent": "Percent (%)",
      "fixed": "Fixed amount"
    },
    "value": "Value",
    "addTier": "Add Tier",
    "noAdjustment": "no adjustment",
    "default": "default",
    "methodsHeading": "Payment methods",
    "methodsHint": "Offline ways you take payment (cash, bank wire, Revolut, …). The default is pre-selected when recording a payment. Card payments via Stripe are configured below.",
    "addMethodLabel": "Add a method",
    "addMethodPlaceholder": "e.g. Bank wire",
    "addMethod": "Add method",
    "methodCard": "card · Stripe",
    "methodOffline": "offline",
    "disabledSuffix": "disabled",
    "managedBelow": "managed below",
    "makeDefault": "Make default",
    "stripeHeading": "Stripe (card payments)",
    "stripeMode": {
      "test": "Test mode",
      "live": "Live mode",
      "none": "Not configured"
    },
    "stripeDevPre": "Local development is using",
    "stripeDevStrong": "sandbox keys from",
    "stripeDevPost": ". The keys are fixed here, but you can still switch card payments on/off.",
    "stripeNoKeyPre": "Encryption key not configured. Run",
    "stripeNoKeyPost": "and redeploy before saving Stripe keys (secrets are encrypted at rest with it). It's separate from any product license key.",
    "stripeErrorPre": "Stored Stripe keys couldn't be decrypted:",
    "stripeErrorMid": ". Check that",
    "stripeErrorPost": "matches the value used when they were saved.",
    "stripeStatusUse": "When enabled, students can pay outstanding fees by card from their portal.",
    "stripeEnable": "Enable card payments",
    "stripePublishable": "Publishable key",
    "stripeSecret": "Secret key",
    "stripeWebhook": "Webhook signing secret",
    "stripeWebhookHelp1": "In your Stripe Dashboard, add a webhook endpoint for the",
    "stripeWebhookHelp2": "event pointing to:",
    "stripeWebhookHelp3": "then paste its signing secret above. A restricted key (",
    "stripeWebhookHelp4": ") scoped to Checkout + PaymentIntents is recommended over the full secret key.",
    "stripeSaveDev": "Save card payments on/off",
    "stripeSave": "Save Stripe settings",
    "remindersHeading": "Reminders & late fees",
    "remindersHint": "A daily job marks overdue payments, sends due-date reminders, and applies late fees per these rules.",
    "sendReminders": "Send payment reminders",
    "daysBefore": "Days before due",
    "applyLateFees": "Apply late fees",
    "lateFeeAmount": "Late fee amount",
    "graceDays": "Grace days",
    "saveAutomation": "Save automation",
    "savedPlaceholder": "•••••••• (saved — leave blank to keep)"
  },
  "email": {
    "noAccessHeading": "Email",
    "noAccess": "You don't have access to email settings.",
    "providerHeading": "Email provider",
    "devOverridePre": "Local development is using the sandbox {provider} key from",
    "devOverridePost": ". Sandbox mode is on, so emails are validated but never delivered.",
    "blockedPre": "Encryption key not configured — set the",
    "blockedPost": "Worker secret before saving an API key.",
    "statusUse": "Used for mailing campaigns and transactional emails (invites, notifications).",
    "sandboxSuffix": " · sandbox (no real delivery)",
    "enableSending": "Enable email sending",
    "provider": "Provider",
    "fromAddress": "From address (verified sender)",
    "fromAddressPlaceholder": "hello@yourschool.com",
    "fromName": "From name",
    "fromNamePlaceholder": "Your Dance School",
    "apiKey": "{provider} API key",
    "save": "Save email settings",
    "fromNameHint": "Leave blank to use your school name."
  },
  "media": {
    "noAccessHeading": "Media",
    "noAccess": "You don't have access to media settings.",
    "uploadRules": "Upload rules",
    "uploadRulesHint": "Limits applied when admins or students upload to the gallery. Allowed types: JPEG, PNG, WebP, GIF (photos); MP4, MOV, WebM (videos).",
    "maxPhoto": "Max photo size (MB)",
    "maxVideo": "Max video size (MB)",
    "maxVideoDuration": "Max video duration (seconds)",
    "save": "Save media settings"
  },
  "calendar": {
    "featureHeading": "Calendar feature",
    "enableFeeds": "Enable calendar feeds",
    "enableFeedsHint": "When off, all private iCal feeds stop working and the portal hides the subscribe page.",
    "yourFeed": "Your feed:",
    "itemsHeading": "Public calendar items",
    "itemsHint": "These appear in everyone's calendar feed — use them for parties, socials and key dates.",
    "title": "Title",
    "date": "Date",
    "startTime": "Start time (optional)",
    "endTime": "End time (optional)",
    "description": "Description (optional)",
    "addItem": "Add item",
    "hidden": "Hidden",
    "emptyItems": "No custom items yet"
  },
  "notifications": {
    "heading": "Admin notifications",
    "hint": "Choose which staff alerts are sent. Student payment and class notifications are always sent and can't be turned off.",
    "newStudent": {
      "label": "New student registered",
      "desc": "When a student completes onboarding."
    },
    "paymentOverdue": {
      "label": "Payments overdue",
      "desc": "When payments become overdue (checked daily)."
    },
    "mediaSubmitted": {
      "label": "Media awaiting approval",
      "desc": "When a student submits a photo or video for approval."
    },
    "eventInterest": {
      "label": "Event interest",
      "desc": "When a student registers interest in an event."
    }
  },
  "appearance": {
    "heading": "Theme",
    "hint": "Choose the colour theme for your school. It applies to everyone across the admin area and the student portal.",
    "current": "Current",
    "darkModeHint": "Light and dark mode is a personal choice — switch it any time with the sun/moon button in the top bar.",
    "saved": "Theme updated"
  },
  "features": {
    "heading": "Feature flags",
    "hint": "Turn major features on or off. When a feature is off, its navigation entry and related screens are hidden.",
    "flags": {
      "events": {
        "label": "Events",
        "desc": "Event management, registration, and the events section."
      },
      "media": {
        "label": "Media gallery",
        "desc": "Photo/video galleries and uploads."
      },
      "mailing": {
        "label": "Mailing",
        "desc": "Mailing lists and bulk email campaigns."
      },
      "calendar": {
        "label": "Calendar",
        "desc": "Private iCal feeds and the portal subscribe page."
      },
      "attendance": {
        "label": "Attendance",
        "desc": "Attendance tracking for class sessions."
      },
      "module_irish_dance": {
        "label": "Irish Dance module",
        "desc": "Competition passes (stars) and grade exams for Irish dance students."
      }
    }
  },
  "contract": {
    "heading": "Terms & Conditions",
    "loadFile": "Load file…",
    "writeHelp1": "Write in Markdown, or load a",
    "writeHelp2": "file.",
    "legacyNote": "This version was authored in the old editor, so the Markdown source is empty. Load a file or type the terms, then publish to convert it.",
    "publish": "Publish",
    "currentVersion": "Current: version {version}",
    "noneYet": "No contract published yet",
    "versionHistory": "Version history",
    "version": "Version {version}",
    "accepted": "{count} accepted",
    "view": "View",
    "noVersions": "No versions yet.",
    "modalHeading": "Terms & Conditions — version {version}",
    "publishedByOne": "Published {date} · accepted by {count} student.",
    "publishedByMany": "Published {date} · accepted by {count} students.",
    "noContent": "This version has no content."
  },
  "backup": {
    "types": {
      "daily": "Daily",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "manual": "Manual",
      "pre_update": "Pre-update"
    },
    "createHeading": "Create a backup",
    "createHint": "Takes an immediate snapshot of the database. Manual backups never expire — delete them yourself when no longer needed. Automated daily/weekly/monthly backups run nightly and are pruned by the retention policy (7 days / 4 weeks / 12 months).",
    "nameLabel": "Backup name",
    "namePlaceholder": "e.g. Before season restructure",
    "create": "Create backup",
    "listHeading": "Backups",
    "emptyHeading": "No backups yet",
    "emptyMessage": "Create one above, or wait for the nightly automated backup.",
    "download": "Download",
    "restore": "Restore",
    "retentionManaged": "retention-managed",
    "retentionTitle": "Automated backups are managed by the retention policy",
    "expiresSuffix": "expires {date}",
    "restoreHeading": "Restore backup",
    "restoreBody1": "Restoring",
    "restoreBody2": "({date}) will",
    "restoreReplace": "replace the entire current database",
    "restoreBody3": "with this snapshot. The app goes into maintenance mode while it runs. This cannot be undone.",
    "typeConfirm1": "Type",
    "typeConfirm2": "to confirm.",
    "restoreDb": "Restore database"
  },
  "toast": {
    "schoolNameRequired": "School name is required",
    "schoolSaved": "School settings saved",
    "logoRemoved": "Logo removed",
    "settingsSaved": "Settings saved",
    "feedCopied": "Feed URL copied",
    "copyFailed": "Copy failed",
    "titleDateRequired": "Title and date are required",
    "calItemAdded": "Calendar item added",
    "mediaSaved": "Media settings saved",
    "emailSaved": "Email settings saved",
    "currencyCode3Ron": "Enter a 3-letter currency code (e.g. RON)",
    "primaryCurrencySaved": "Primary currency saved",
    "currencyCode3Eur": "Enter a 3-letter currency code (e.g. EUR)",
    "currencyAdded": "Currency added",
    "currencyRemoved": "Currency removed",
    "billingSaved": "Billing settings saved",
    "stripeSaved": "Stripe settings saved",
    "feeFieldsRequired": "Name, amount, and currency are required",
    "feeCreated": "Fee created",
    "tierNameRequired": "Tier name is required",
    "tierCreated": "Price tier created",
    "methodNameRequired": "Enter a method name",
    "methodAdded": "Payment method added",
    "defaultMethodSet": "Default method set",
    "methodDeleted": "Payment method deleted",
    "feeNameCurrencyRequired": "Name and currency are required",
    "feeUpdated": "Fee updated",
    "feeArchived": "Fee archived",
    "feeRestored": "Fee restored",
    "feeDeleted": "Fee deleted",
    "importTypeError": "Only Markdown (.md) or text (.txt) files can be imported",
    "fileTooLarge": "File too large (max 1 MB of text)",
    "fileLoaded": "File loaded into the editor",
    "fileReadError": "Could not read file",
    "contractEmpty": "Contract is empty",
    "contractPublished": "Contract published",
    "tagCreated": "Tag created",
    "eventTypeCreated": "Event type created",
    "eventTypeDeleted": "Event type deleted",
    "backupNameRequired": "Enter a name for the backup",
    "backupCreated": "Backup created",
    "backupDeleted": "Backup deleted",
    "restoredOne": "Restored {rows} row across {tables} tables",
    "restoredMany": "Restored {rows} rows across {tables} tables"
  }
}
